import { toast } from "react-toastify";

import { removeAppNotification } from "components";
import { useTypedQuery } from "hooks";
import { KeyLockersQueryKeys } from "modules/KeyLockersDashboard/queryKeys";

export const useCallForHelp = () => useTypedQuery({ queryKey: KeyLockersQueryKeys.callForHelp, initialData: [] }).data;

export const removeCallForHelpNotification = (keyLockerCallForHelpId: string) => {
  toast.dismiss(keyLockerCallForHelpId);
  removeAppNotification(keyLockerCallForHelpId);
};
